import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageClaimSettlement } from '@/views/screens/Claims/types';

export interface GetClaimSettlementsRequestParams {
  claimKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface ClaimSettlementsResponse {
  data: LossAndDamageClaimSettlement[];
  nextPage?: number;
  totalRows: number;
  totalAmount: number;
}

export const PAGE_SIZE_DEFAULT = 10;

export const getClaimSettlementsAPI = (params: GetClaimSettlementsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      claimKey: params.claimKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'SettlementSeq',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimSettlement`,
  });
};

export const fetchClaimSettlements = async (
  params: GetClaimSettlementsRequestParams,
): Promise<ClaimSettlementsResponse> => {
  const response: AxiosResponse<ClaimSettlementsResponse> = await getClaimSettlementsAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const totalPages = Math.ceil(Number(data.totalRows ?? 0) / pageSize);
  const hasMore = Number(params.pageIndex) < totalPages;

  return {
    ...data,
    nextPage: hasMore ? Number(params.pageIndex) + 1 : undefined,
  };
};
